<script lang="ts" setup>
import FloatLabel from 'primevue/floatlabel';
import type { FloatLabelVariant } from '~/types/components/base/FloatLabel';
import { IN } from '~/utils/enums/components/base/FloatLabel';

const {
  label = '',
  floatingLabel = true,
  floatingLabelVariant = IN,
} = defineProps<{
  label?: string;
  floatingLabel?: boolean;
  floatingLabelVariant?: FloatLabelVariant;
}>();

const labelId = computed(() => {
  if (!label) return '';

  return label
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '-');
});

const variant = computed(() => {
  return floatingLabel ? floatingLabelVariant : '';
});
</script>

<template>
  <div class="app-floating-label-wrapper">
    <FloatLabel v-if="floatingLabel" :variant="variant">
      <label
        v-if="floatingLabel"
        :for="labelId"
        class="app-floating-label-wrapper__label"
        >{{ label }}</label
      >
      <slot :label-id="labelId" />
    </FloatLabel>

    <slot v-else :label-id="labelId" />

    <slot name="overlay" />
  </div>
</template>

<style scoped lang="scss">
.app-floating-label-wrapper {
  &__label {
    z-index: 1;
  }
}
</style>
